export const API_URLS = {
  setPlaybackProgressService: '/v2/heartbeat/',
};
